import { connect } from 'react-redux';
import SerialNumbers from './SerialNumbers';
import React from 'react';
import { ILinesHandle, ILinesProperties } from './SerialNumbers.properties';

// const params = new URLSearchParams(location.search);

const mapStateToProps = () => ({
    selectedMovementEnquiryId: '', //purchaseOrdersSelectors.selected(state)?.PurchaseOrder ?? params.get('PurchaseOrder'),
});

const ContainerComponent = (props: Omit<ILinesProperties, 'classes' | 'calculateCellValueChange'> & { forwardRef?: React.Ref<ILinesHandle> }) => {

    return <SerialNumbers
        {...props}
        innerRef={props?.forwardRef}
    />;
};

export default connect(mapStateToProps, null)(React.forwardRef(ContainerComponent));
